import Collapsable from "../lib/Collapsable";

const state = {
  elements: {},
  collasables: [],
  isOpen: false,
};

const init = () => (
  cacheElements(),
  initCollapsables()
);

const initCollapsables = () => {
  state.elements.collaspsableLinks?.forEach(item => {
    const collapsableContainer = item.querySelector('.menu-drawer__menu-collapsable-wrapper')
    const collapsableContent = item.querySelector('.menu-drawer__menu--item-content');
    const collapsableIToggler = item.querySelector('.menu-drawer__menu-collapsable-icons');
    const behaviour = collapsableContainer.dataset?.behaviour;
    if (!collapsableContent) return;
    state.collasables.push(new Collapsable({
      element: collapsableContent,
      toggler: behaviour === 'collapse' ? collapsableContainer : collapsableIToggler,
      openClass: 'accordion-c--open',
      container: collapsableContainer,
      resetMedia: '(min-width: 1140px)',
      defaultHeight: 'auto'
    }))
  });
};

const cacheElements = () => {
  const drawerContainer = document.getElementById('menu-drawer');
  if (!drawerContainer) return;
  state.elements = {
    collaspsableLinks: Array.from(drawerContainer.querySelectorAll('.menu-drawer__menu--item-collapsable')),
  };
};

export default init;